import { hotjar } from "react-hotjar";

import { dynamicConfig } from "../config";

const hjid = dynamicConfig.isProduction ? 3005609 : 3145764;
const hjsv = 6;

hotjar.initialize(hjid, hjsv);

export const HotJar = hotjar;
